const BASE_URL = process.env.SPINNER_DATA_CDN_URL;

export const VEX_SPINNER_ENDPOINTS = {
  SPINNER_DATA: `${BASE_URL}/spinnerdata`
};
